import { createAction, props } from '@ngrx/store';
import {
  SimulatedFlightSkeleton,
  PagedSimulatedFlightAudit
} from '../../+models/simulated-flight.audit.model';

export const ResetSimulatedFlight = createAction('[SharedAudit SimulatedFlight] Reset');

export const UpdateLogbookSelectedPilot = createAction(
  '[SharedAudit SimulatedFlight] Update Logbook Selected Pilot',
  props<{ crewMemberId: number }>()
);

export const LoadSimulatedFlightSkeletons = createAction(
  '[SharedAudit SimulatedFlight] Load SimulatedFlight Skeletons'
);

export const SimulatedFlightSkeletonsLoaded = createAction(
  '[SharedAudit SimulatedFlight] SimulatedFlight Skeletons Loaded',
  props<{ skeletons: SimulatedFlightSkeleton[] }>()
);

export const SimulatedFlightSkeletonsLoadError = createAction(
  '[SharedAudit SimulatedFlight] SimulatedFlight Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadSimulatedFlightAudit = createAction(
  '[SharedAudit SimulatedFlight] Load SimulatedFlight Audit',
  props<{ simulatedFlightId: number }>()
);

export const LoadNextPageSimulatedFlightAudit = createAction(
  '[SharedAudit SimulatedFlight] Load NextPage SimulatedFlight Audit',
  props<{ simulatedFlightId: number }>()
);

export const SimulatedFlightAuditLoaded = createAction(
  '[SharedAudit SimulatedFlight] SimulatedFlight Audit Loaded',
  props<{ simulatedFlightId: number; audits: PagedSimulatedFlightAudit }>()
);

export const SimulatedFlightAuditLoadError = createAction(
  '[SharedAudit SimulatedFlight] SimulatedFlight Audit Load Error',
  props<{ err: any }>()
);
